<template>
    <FilterBody
        :label="t('projectclient.projectlist.table.contracttypes.header')"
        :items="contractTypeAggregations"
        :selected-items="screenSizeSearchParams.contractTypes"
        @reset="projectListFiltersStore.handleResetCategory('contractTypes')"
        @check:item="handleCheckBoxChange"
    >
        <template #item="{item}">
            {{ `${t(`projectclient.projectlist.table.contracttypes.value.${item.label}`)} (${item.count})` }}
        </template>
    </FilterBody>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import type {TypedAggregationResource} from '@common/composables';
    import {useScreenSizeStore} from '@common/stores';
    import {useProjectsListStore, useProjectsListFiltersStore} from '@features/projects-list/stores';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import type {ContractType} from '@api';
    import FilterBody from '../wrappers/FilterBody.vue';

    const {t} = useTranslation();

    const screenSizeStore = useScreenSizeStore();
    const {isSmallScreen} = storeToRefs(screenSizeStore);

    const projectListStore = useProjectsListStore();
    const {searchParams} = storeToRefs(projectListStore);

    const projectListFiltersStore = useProjectsListFiltersStore();
    const {contractTypeAggregations, temporarySearchParams} = storeToRefs(projectListFiltersStore);

    const screenSizeSearchParams = computed(() => {
        if (isSmallScreen.value) {
            return temporarySearchParams.value;
        } else {
            return searchParams.value;
        }
    });

    function handleCheckBoxChange(item: TypedAggregationResource<ContractType>) {
        projectListFiltersStore.handleUpdateCategory('contractTypes', item.value);
    }
</script>
